//设置cookie,增加到vue实例方便全局调用
//vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
//当然，如果session保存到vuex的话除外
//全局引入vue
// function str2asc(strstr) {
//   return ("0" + strstr.charCodeAt(0).toString(16)).slice(-2);
// }
//
// function asc2str(ascasc) {
//   return String.fromCharCode(ascasc);
// }
//
// /*这里开始时UrlEncode和UrlDecode函数*/
// function UrlEncode(str) {
//   var ret = "";
//   var strSpecial = "!\"#$%&'()*+,/:;<=>?[]^`{|}~%";
//   var tt = "";
//
//   for (var i = 0; i < str.length; i++) {
//     var chr = str.charAt(i);
//     var c = str2asc(chr);
//     tt += chr + ":" + c + "n";
//     if (parseInt("0x" + c) > 0x7f) {
//       ret += "%" + c.slice(0, 2) + "%" + c.slice(-2);
//     } else {
//       if (chr === " ")
//         ret += "+";
//       else if (strSpecial.indexOf(chr) !== -1)
//         ret += "%" + c.toString(16);
//       else
//         ret += chr;
//     }
//   }
//   console.log('---encode---', ret)
//   return ret;
//
// }
//
// function UrlDecode(str) {
//   var ret = "";
//   for (var i = 0; i < str.length; i++) {
//     var chr = str.charAt(i);
//     if (chr === "+") {
//       ret += " ";
//     } else if (chr === "%") {
//       var asc = str.substring(i + 1, i + 3);
//       if (parseInt("0x" + asc) > 0x7f) {
//         ret += asc2str(parseInt("0x" + asc + str.substring(i + 4, i + 6)));
//         i += 5;
//       } else {
//         ret += asc2str(parseInt("0x" + asc));
//         i += 2;
//       }
//     } else {
//       ret += chr;
//     }
//   }
//   console.log('---decode--', ret)
//   // alert(UrlDecode('%f7%f7'))
//   return ret;
// }


var cookie = {
  setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    // console.log(value)
    exdate.setTime(exdate.getTime() + expiredays);
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + encodeURI(value) + ";path=/" + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
    // document.cookie = c_name + "=" + UrlEncode(value) + ";path=/" + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  },
  getCookie(name) {
    // console.log(document.cookie)
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      // console.log(arr[2])
      return (decodeURI(arr[2]));
      // return (unescape(arr[2]));
      //   return (UrlDecode(arr[2]));
    } else
      return null;
    // if(document.cookie.length>0){
    //   let cname = encodeURIComponent(name)
    //   let allcookies = document.cookie
    //   cname +="="
    //   let pos = allcookies.indexOf(cname)
    //   if (pos!==-1){
    //     let start = pos + cname.length
    //     let end = allcookies.indexOf(";", start)
    //
    //      if (end=== -1){
    //        end = allcookies.length
    //   }
    //   let value = allcookies.substring(start, end)
    //     return decodeURIComponent(value)
    //   }else{
    //     return ""
    //   }
    // }


  },
  delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 100);
    var cval = cookie.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";path=/" + ";expires=" + exp.toGMTString();
  }
}

export default cookie;



//////////////////
// WEBPACK FOOTER
// ./static/js/cookie.js
// module id = null
// module chunks = 